<template>
  <div>
    <header
      :style="{ color: style.color }"
      :class="{ hidden: hideHeader }"
      class="
        pointer-events-none
        absolute
        md:fixed
        top-0
        right-0
        md:h-full
        z-50
        w-full
        md:w-auto
      "
    >
      <div
        class="
          pointer-events-auto
          flex
          md:flex-col
          justify-between
          items-center
          p-4
          md:p-10
          lg:p-12
          md:h-full
        "
        :class="{ 'ml-48': hasLeftMenu }"
      >
        <div
          class="relative h-16 md:h-48 md:w-full menu-scale"
          :class="{ open: opened }"
        >
          <div
            @click.stop
            ref="menu"
            :class="menuClasses"
            :style="styles"
            style="height: 80px; width: 80px"
            class="
              border border-current
              absolute
              top-0
              right-0
              overflow-hidden
              transition-bg
              z-10
            "
          >
            <button @click="toggle" class="p-5 outline-none absolute">
              <menu-icon :opened="opened" />
            </button>
            <div v-if="opened" class="p-4 lg:p-6 show-opened">
              <ul class="main-menu text-3xl text-right mb-12">
                <li
                  v-for="item in menuList"
                  :key="item.title"
                  class="whitespace-no-wrap"
                >
                  <a
                    v-if="item.path.includes('http')"
                    :href="item.path"
                    target="_blank"
                    >{{ item.title }}</a
                  >
                  <router-link v-else :to="localeLink(item.path)" class="p-1">{{
                    item.title
                  }}</router-link>
                </li>
                <li v-if="collapsed" class="text-orange-brand">
                  <button @click="collapsed = false" class="outline-none">
                    &darr;
                  </button>
                </li>
              </ul>
              <div
                class="
                  w-full
                  flex
                  justify-between
                  items-center
                  overflow-hidden
                  whitespace-no-wrap
                "
              >
                <div
                  class="
                    w-24
                    h-20
                    border border-current
                    flex
                    justify-center
                    items-center
                  "
                >
                  <button
                    @click="changeLocale"
                    class="text-xl cursor-pointer outline-none w-full h-full"
                  >
                    {{ lang[locale] }}
                  </button>
                </div>
                <div class="text-sm text-right">
                  <transition name="fade">
                    <div v-if="weather" class="">
                      <span
                        >GZ <i class="wi mx-1" :class="getIcon('cn')"></i>
                        {{ getTemp(0) }}°</span
                      >
                      <span class="ml-3"
                        >BLN <i class="wi mx-1" :class="getIcon('de')"></i>
                        {{ getTemp(1) }}°</span
                      >
                    </div>
                  </transition>
                  <transition name="fade">
                    <div v-show="$store.state.about">
                      <div v-if="!forceClosed" class="text-right">
                        <span>{{ $t('general', 'openings') }}</span
                        ><br />
                        <span v-if="isOpen" class="ml-3 text-green"
                          >{{ $t('general', 'currently')
                          }}{{ $t('general', 'open') }}</span
                        >
                        <span class="ml-3 text-red" v-else
                          >{{ $t('general', 'currently')
                          }}{{ $t('general', 'closed') }}</span
                        >
                      </div>
                      <div v-else class="text-right">
                        <span class="text-red">{{
                          $t('general', 'closed')
                        }}</span>
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </div>
          </div>
          <transition name="fade">
            <div
              v-if="!opened"
              @click.stop
              ref="search"
              :style="styles"
              style="margin-top: 79px; height: 80px; width: 80px"
              class="
                border border-current
                absolute
                top-0
                right-0
                transition-bg
                z-0
                hidden
                md:block
              "
            >
              <button
                @click="toggleSearch"
                class="p-5 my-2 mx-2 outline-none absolute"
              >
                <svg
                  width="23"
                  height="25"
                  viewBox="0 0 21 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="9.59424"
                    cy="9.60278"
                    r="9"
                    stroke="currentColor"
                  />
                  <line
                    y1="-0.5"
                    x2="7.07107"
                    y2="-0.5"
                    transform="matrix(0.707108 0.707106 -0.707108 0.707106 15.0942 17.1028)"
                    stroke="currentColor"
                  />
                </svg>
              </button>

              <div v-if="searching" class="relative h-full w-full">
                <search-bar @hide="searching = false" />
              </div>
            </div>
          </transition>
        </div>

        <div class="flex-1 relative hidden md:block">
          <!-- Remove for now -->
          <div v-if="false && hasMedia && !searching">
            <audio-control />
          </div>
        </div>
        <div class="order-first md:order-last">
          <router-link :to="localeLink('')" :class="{ hidden: !showLogo }">
            <app-logo :class="{ up: showShare }" />
          </router-link>
        </div>
        <share v-if="showShare" />
      </div>
    </header>

    <!-- mobile header -->
    <!-- <header class="md:hidden sticky top-0 p-4">
      <div class="flex">
        <router-link :to="localeLink('')" class="p-2">
          <img src="../assets/TimesMuseum.svg"/>
        </router-link>
        <div class="relative flex-1 text-center">
          <div @click.stop ref="mMenu" :style="style" class="border border-current absolute right-0 top-0 overflow-hidden transition-bg">
            <button class="px-3 py-4 outline-none">
              <svg width="24" height="13" viewBox="0 0 46 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="0.889648" y1="1.27783" x2="45.8896" y2="1.27783" stroke="currentColor"/>
                <line x1="0.889648" y1="11.7222" x2="45.8896" y2="11.7222" stroke="currentColor"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </header> -->
  </div>
</template>

<script>
import anime from 'animejs'
import AppLogo from '@/components/AppLogo'
import SearchBar from '@/components/SearchBar'
import AudioControl from '@/components/AudioControl'
import MenuIcon from '@/components/MenuIcon'
import Share from '@/components/Share'
import bus from '@/bus'

const baseHeight = 80

export default {
  name: 'AppHeader',
  data() {
    return {
      opened: false,
      collapsed: false,
      searching: false,
      menu: {
        en: [
          // TODO: CONNECT TO STATICTEXT?
          { title: 'Now', path: '' },
          { title: 'Program', path: '/program' },
          { title: 'Learning & Experience', path: '/learning-and-experience' },
          { title: 'Journal', path: '/journal' },
          { title: 'Media Lab', path: 'https://medialab.timesmuseum.org' },
          // { title: 'Art+', path: 'https://shop108844269.taobao.com/' },
          { title: 'About', path: '/about' },
          { title: 'Visit', path: '/visit' },
          { title: 'Times Art Center Berlin', path: '/berlin' }
        ],
        cn: [
          { title: '首页', path: '' },
          { title: '项目', path: '/program' },
          { title: '学习和体验', path: '/learning-and-experience' },
          { title: '期刊', path: '/journal' },
          { title: '媒介实验室', path: 'https://medialab.timesmuseum.org' },
          // { title: '艺术+', path: 'https://shop108844269.taobao.com/' },
          { title: '关于我们', path: '/about' },
          { title: '参观', path: '/visit' },
          { title: '时代艺术中心 (柏林)', path: '/berlin' }
        ]
      },
      lang: {
        en: '中文',
        cn: 'EN'
      },
      change: {
        en: 'cn',
        cn: 'en'
      }
    }
  },
  computed: {
    hasLeftMenu() {
      return ['journal', 'issue', 'article'].includes(this.$route.name)
    },
    locale: {
      get() {
        return this.$store.state.locale
      },
      set(newVal) {
        this.$store.commit('CHANGE_LOCALE', newVal)
      }
    },
    changeLink() {
      const here = location.pathname
      return here.replace('/' + this.locale, '/' + this.change[this.locale])
    },
    menuClasses() {
      return this.searching ? 'opacity-0 pointer-events-none' : ''
    },
    menuList() {
      return this.collapsed
        ? this.menu[this.locale].slice(0, 4)
        : this.menu[this.locale]
    },
    showLogo() {
      const nope = ['journal', 'article', 'issue']
      return !nope.includes(this.$route.name)
    },
    showShare() {
      return this.$route.name !== 'home'
    },
    hideHeader() {
      return this.$route.name === 'login'
    },
    styles() {
      return this.$store.state.style
    },
    style() {
      return {
        color: this.styles.color,
        backgroundColor:
          this.opened || this.searching
            ? this.styles.backgroundColor
            : 'transparent'
      }
    },
    hasMedia() {
      return this.$store.state.hasMedia
    },
    firstVisit() {
      return this.$store.state.firstVisit
    },
    weather() {
      return this.$store.state.weather
    },
    time() {
      return this.$store.state.time
    },
    isOpen() {
      return this.time.cn.open
    },
    forceClosed() {
      return this.$store.state.closed === 'true'
    },
    location() {
      return this.$store.state.location
    }
  },
  methods: {
    getTemp(index) {
      if (this.weather) {
        return Math.round(this.weather[index].main.temp)
      } else {
        return '-'
      }
    },

    changeLocale() {
      this.$router.push(this.changeLink)
    },

    toggle() {
      bus.$emit('close-others')
      this.opened = !this.opened
      if (!this.opened && this.firstVisit) {
        this.notFirst()
      }
    },

    toggleSearch() {
      bus.$emit('close-others')
      this.searching = !this.searching
    },

    showMenu() {
      const el = this.$refs.menu

      const complete = () => {
        el.style.height = 'auto'
        el.classList.add('opened')
      }
      el.style.height = 'auto'
      const t = anime.timeline({ complete })
      const r = el.getBoundingClientRect()
      const h = r.height
      el.style.height = baseHeight + 'px'
      const w = window.innerWidth
      let width = 380

      if (w < 440) {
        width = w - 32
      }
      t.add({
        targets: el,
        height: h,
        width: width,
        duration: 200,
        easing: 'easeInOutCubic'
      })
    },
    hideMenu() {
      const el = this.$refs.menu
      const t = anime.timeline()
      const h = el.getBoundingClientRect().height

      el.classList.remove('opened')
      el.style.height = h + 'px'
      t.add({
        targets: el,
        height: baseHeight,
        width: 80,
        duration: 200,
        easing: 'easeInOutCubic'
      })
      // this.collapsed = true
    },
    showSearch() {
      const el = this.$refs.search

      const complete = () => {
        el.classList.add('opened')
      }
      const t = anime.timeline({ complete })
      el.style.width = baseHeight + 'px'
      t.add({
        marginTop: 0,
        targets: el,
        width: window.innerWidth - 96,
        duration: 280,
        easing: 'easeInOutCubic'
      })
    },
    hideSearch() {
      const el = this.$refs.search
      const complete = () => {
        this.searching = false
      }
      const t = anime.timeline({ complete })

      el.classList.remove('opened')
      t.add({
        marginTop: baseHeight - 1,
        targets: el,
        width: baseHeight,
        duration: 280,
        easing: 'easeInOutCubic'
      })
    },
    firstVisitState() {
      const q = window.matchMedia('(min-width: 768px)')
      if (q.matches) {
        // default open since menu is simplified
        this.collapsed = false
        this.opened = true
      }
    },
    notFirst() {
      this.$store.commit('FIRST_VISIT', false)
      this.opened = false
      setTimeout(() => {
        this.collapsed = false
      }, 300)
    },
    getIcon(country) {
      const weather = this.$store.state.weather
      let icon = ''

      if (country === 'cn') {
        icon = weather[0].weather[0].icon
      } else {
        icon = weather[1].weather[0].icon
      }

      if (icon === '01d') {
        return 'wi-day-sunny'
      } else if (icon === '01n') {
        return 'wi-night-clear'
      } else if (['09d', '10d'].includes(icon)) {
        return 'wi-day-rain'
      } else if (['09n', '10n'].includes(icon)) {
        return 'wi-night-rain'
      } else if (icon === '02d') {
        return 'wi-day-cloudy'
      } else if (icon === '02n') {
        return 'wi-night-alt-cloudy'
      } else if (['03d', '03n', '04d', '04n'].includes(icon)) {
        return 'wi-cloud'
      } else if (icon === '11d') {
        return 'wi-day-lightning'
      } else if (icon === '11n') {
        return 'wi-night-alt-lightning'
      } else if (icon === '13d') {
        return 'wi-day-snow'
      } else if (icon === '13n') {
        return 'wi-night-alt-snow'
      } else if (icon === '50d') {
        return 'wi-day-fog'
      } else if (icon === '50n') {
        return 'wi-night-fog'
      } else {
        return ''
      }
    },
    getOpenIcon() {
      if (this.time.cn.open) {
        return 'clock'
      } else {
        return 'closed'
      }
    }
  },
  watch: {
    $route({ params, name }) {
      if (this.locale !== params.locale) {
        this.locale = params.locale
      }
      if (!this.firstVisit || name !== 'home') {
        this.notFirst()
      }
    },
    opened(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.showMenu()
        })
      } else {
        this.hideMenu()
      }
    },
    searching(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.showSearch()
          bus.$emit('searching', newVal)
        })
      } else {
        this.hideSearch()
        bus.$emit('searching', newVal)
      }
    },
    firstVisit(newVal) {
      if (!newVal) return
      this.firstVisitState()
    },
    location(newVal) {
      if (newVal) {
        this.$store.dispatch('getWeather')
      }
    }
  },
  mounted() {
    this.$store.dispatch('setTimes')
    this.$store.dispatch('getWeather')

    if (this.firstVisit) {
      this.firstVisitState()
    }
    bus.$on('close-menu', () => {
      this.opened = false
      this.searching = false
    })
    window.addEventListener('click', () => {
      bus.$emit('close-others')
      setTimeout(() => {
        this.opened = false
        this.searching = false
        if (this.firstVisit) {
          this.notFirst()
        }
      }, 100)
    })
    window.addEventListener(
      'scroll',
      () => {
        // hide the menu, after a delay
        setTimeout(() => {
          this.notFirst()
        }, 300)
      },
      { once: true }
    )
  },
  components: { AppLogo, SearchBar, AudioControl, MenuIcon, Share }
}
</script>

<style lang="stylus">
@import '../css/weather-icons.css';

.main-menu .router-link-exact-active {
  @apply: border-b border-current;
}

.show-opened {
  opacity: 0;
  transition: opacity 0.3s ease-out;
}

.opened .show-opened {
  opacity: 1;
}

.up {
  margin-bottom: 90px;
}

@media screen and (max-height: 780px) {
  .up {
    margin-bottom: 66px;
  }
}

@media screen and (max-height: 630px) {
  .up {
    margin-bottom: 0;
  }
}

@media screen and (max-width: 630px) {
  .up {
    margin-bottom: 0;
  }
}
</style>
